import React, {useEffect, useRef} from 'react';
import {style, classes, vars} from './clamped-text.st.css';
import {useElementLayoutBinding, useRenderState} from "../hooks";
import {referencesEqualityComparer} from "@wix/devzai-utils-common";

export const ClampedText = React.memo(function ClampedText (props: ClampedText.Props) {
    const {
        children,
        onIsClampedChanged,
        maxLines,
        clampText,

        style: styleProp,
        className,
        ...htmlAttributes
    } = props;

    const renderState = useRenderState({
        onIsClampedChanged
    })

    const clampingEnabled = !!maxLines;

    const textContainerRef = useRef<HTMLDivElement>(null);

    const isClampedFromBinding = useElementLayoutBinding(
        textContainerRef,
        elementIsClamped,
        referencesEqualityComparer,
        clampText) ?? false;

    const isClamped = isClampedFromBinding && clampingEnabled;

    useEffect(() => {
        renderState.current.onIsClampedChanged?.(isClamped)
    }, [renderState, isClamped])

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {clampingEnabled: clampText}, className)}
            style={{
                ...styleProp,
                [vars.maxLines]: maxLines
            }}
        >
            <div
                className={style(classes.testTextContainer)}
                ref={textContainerRef}
            >
                {children}
            </div>
            <div
                className={style(classes.textContainer)}
                ref={textContainerRef}
            >
                {children}
            </div>
        </div>
    );
});

export namespace ClampedText {

    export interface Props extends React.HTMLAttributes<any> {
        children: React.ReactNode;

        onIsClampedChanged?: (isClamped: boolean) => void;
        maxLines: number;
        clampText: boolean;
    }
}

function elementIsClamped(element: HTMLElement) : boolean {
    return element.offsetHeight < element.scrollHeight;
}